import useTranslations from '@/i18n/useTranslations';

export default function KaleidoscopeControls({
  canUndo,
  hasStroke,
  isSaving,
  isRevealed,
  // inkDriftEnabled,
  onReset,
  onReveal,
  onSave,
  onToggleOrganic,
  // onToggleInkDrift,
  onToggleSmoothing,
  onUndo,
  organicMode,
  smoothingEnabled,
}) {
  const t = useTranslations('common.newspaper.art_games.kaleidoscope.controls');
  const switches = [
    {
      id: 'smoothing',
      label: t('switches.smoothing.label'),
      checked: smoothingEnabled,
      onChange: onToggleSmoothing,
    },
    {
      id: 'organic',
      label: t('switches.organic.label'),
      checked: organicMode,
      onChange: onToggleOrganic,
    },
    // Temporarily hide the Ink drift toggle until the feature returns.
    // {
    //   id: 'ink-drift',
    //   label: 'Ink drift',
    //   description: 'Gently nudges lines as you draw',
    //   checked: inkDriftEnabled,
    //   onChange: onToggleInkDrift,
    // },
  ];

  return (
    <aside className="kaleidoscope-controls" aria-label={t('aria.controls')}>

      <div className="kaleidoscope-controls__group">
        <h2 className="kaleidoscope-controls__heading">{t('headings.studio_switches')}</h2>
        <div className="kaleidoscope-switches-grid">
          {switches.map((toggle) => (
            <label
              key={toggle.id}
              className="kaleidoscope-switch"
              data-active={toggle.checked}
            >
              <input
                type="checkbox"
                checked={toggle.checked}
                onChange={(event) => toggle.onChange(event.target.checked)}
                aria-checked={toggle.checked}
                aria-label={toggle.label}
              />
              <span className="kaleidoscope-switch__track" aria-hidden="true">
                <span className="kaleidoscope-switch__thumb" />
              </span>
              <span className="kaleidoscope-switch__copy">{toggle.label}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="kaleidoscope-controls__group">
        <h2 className="kaleidoscope-controls__heading">{t('headings.actions')}</h2>
        <div className="kaleidoscope-actions">
          <button
            type="button"
            className="kaleidoscope-action kaleidoscope-action--reveal"
            onClick={onReveal}
            disabled={!hasStroke || isRevealed}
          >
            {t('actions.reveal')}
          </button>
          <button
            type="button"
            className="kaleidoscope-action"
            onClick={onSave}
            disabled={!isRevealed || isSaving}
          >
            {isSaving ? t('actions.saving') : t('actions.save')}
          </button>
          <button type="button" className="kaleidoscope-action" onClick={onReset}>
            {t('actions.reset')}
          </button>
          <button type="button" className="kaleidoscope-action" onClick={onUndo} disabled={!canUndo}>
            {t('actions.undo')}
          </button>
        </div>
      </div>
    </aside>
  );
}
